"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appleChannelsProductPageBrowseClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function appleChannelsProductPageBrowseClient(networkClient) {
    return {
        findProductPageBrowseOptions: async (params) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/options/product-page-browse`);
        },
        getPpbChannel: async (params) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/product-page-browse`);
        },
        listPpbChannels: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/product-page-browse`, query, config);
        },
        createPpbChannel: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/product-page-browse`, body);
        },
        updatePpbChannel: async (params, body) => {
            return networkClient.putHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/product-page-browse`, body);
        },
        deletePpbChannel: async (params) => {
            return networkClient.deleteHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/product-page-browse`);
        },
        getPpbChannelRegion: async (params) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/product-page-browse/regions/${params.regionId}`);
        },
        listPpbChannelRegions: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/product-page-browse/regions`, query, config);
        },
        createPpbChannelRegion: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/product-page-browse/regions`, body);
        },
        updatePpbChannelRegion: async (params, body) => {
            return networkClient.putHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/product-page-browse/regions/${params.regionId}`, body);
        },
        deletePpbChannelRegion: async (params) => {
            return networkClient.deleteHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/product-page-browse/regions/${params.regionId}`);
        },
        importPpbCampaign: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/product-page-browse/import`, body);
        },
        updatePpbCampaign: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/product-page-browse/update-import`, body);
        },
        syncPpbChannel: async (params, body = {}) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/product-page-browse/sync`, body);
        },
        listPpbChannelCampaignNames: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/product-page-browse/campaign-names`, query, config);
        },
        updatePpbChannelCampaignNames: async (params, body) => {
            return networkClient.putHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/product-page-browse/campaign-names`, body);
        },
        getPpbChannelSynchronisation: async (params) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/product-page-browse/synchronisation`);
        },
    };
}
exports.appleChannelsProductPageBrowseClient = appleChannelsProductPageBrowseClient;
